import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { style } from './text.style.js'
import { styleMap } from 'lit/directives/style-map.js'
import { fontStyles, fontVariantsType } from 'elements/_shared/fonts.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


export const textAsOptions = ['span', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'] as const
export type textAsOptionsType = typeof textAsOptions

@customElement('cse-text')
export class CSEText extends LitElement {
  static override styles: CSSResultGroup = [fontStyles, hostStyle, style]

  @property({ type: String })
  as: textAsOptionsType[number] = 'p'

  @property({ type: String })
  variant: fontVariantsType[number] = 'body'

  @property({ type: Number })
  clamp: number | null = null

  @property({ type: Boolean, attribute: 'has-icon' })
  hasIcon: boolean = false

  private renderSimpleText = () => html`
    <slot></slot>
  `

  private renderWithIcons = () => html`
    <slot name="prefix"></slot>
    <div class="content">
      <slot></slot>
    </div>
    <slot name="suffix"></slot>
  `

  override render() {
    const classes = `cse-text font-${this.variant} ${this.clamp != null ? 'clamped' : ''} ${this.hasIcon ? 'has-icon' : ''}`
    const styles = styleMap(this.clamp != null ? { '--cse-text-line-clamp': String(this.clamp) } : {})
    const content = this.hasIcon ? this.renderWithIcons() : this.renderSimpleText()

    switch (this.as) {
      case 'span':
        return html`<span class=${classes} style=${styles}>${content}</span>`
      case 'h1':
        return html`<h1 class=${classes} style=${styles}>${content}</h1>`
      case 'h2':
        return html`<h2 class=${classes} style=${styles}>${content}</h2>`
      case 'h3':
        return html`<h3 class=${classes} style=${styles}>${content}</h3>`
      case 'h4':
        return html`<h4 class=${classes} style=${styles}>${content}</h4>`
      case 'h5':
        return html`<h5 class=${classes} style=${styles}>${content}</h5>`
      case 'h6':
        return html`<h6 class=${classes} style=${styles}>${content}</h6>`
      default:
        return html`<p class=${classes} style=${styles}>${content}</p>`
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-text': CSEText
  }
}
